<template>
  <v-container fluid class="event" v-if="event" :class="[{'pre-match': !liveEvent}, {'live-match': liveEvent}]">
    <template v-if="isEventStreamable">
      <div :class="['stream-eventinfo-switcher', { 'stream-active': isLiveStreamVisible }]">
        <span :class="['tab', { active: !isLiveStreamVisible }]" @click.stop="showEventInfo()"><v-icon>info_outline</v-icon>Back to Event Info</span>
        <span :class="['tab', { active: isLiveStreamVisible }, { disabled: !isLiveEventPage }]" @click.stop="showLiveStream()"><v-icon>play_arrow</v-icon>Watch Live</span>
      </div>
    </template>
    <template v-if="!isLiveStreamVisible || !isLiveEventPage || !liveStream">
      <template v-if="bettingDataMatcherinitiallLoad && betRadarId">
        <div v-if="!mobileBigAndBelow && (idFwMarketgroup || liveEvent) && isFastSwitchEnabled" class="fast_switch_holder">
          {{event.fosportname || event.sportname}} <span @click="toggleFastSwitch" class="fast_swich_arrow_down"><v-icon>keyboard_arrow_down</v-icon></span>
         </div>
        <bet-radar-widget v-if="betRadarWidgetVersion === 'V1'" :betradarid="betRadarId" :isLive="(liveEvent && liveEvent.idfoevent) ? true : false"></bet-radar-widget>
        <bet-radar-widget-v2 v-else :betradarId="betRadarId"></bet-radar-widget-v2>
      </template>
      <!-- not having betRadarId -->
      <template v-else>
        <div class="event_header" :class="'sport-' + event.idfosporttype">
          <div class="competition-live" :class="[{'pre-match': !liveEvent}, {'live-match': liveEvent}]">
            <section class="competition-name"  :class="{'competitionname-betradar-id': betRadarId}">
              <div>{{ event && event.fosportname || event.sportname }}</div>
              <span v-if="!mobileBigAndBelow && (idFwMarketgroup || liveEvent) && isFastSwitchEnabled" @click="toggleFastSwitch" class="fast_swich_arrow_down"><v-icon>keyboard_arrow_down</v-icon></span>
            </section>
            <!-- <section class="live-event" v-if="liveEvent"><div>LIVE</div></section> -->
          </div>
          <!-- Live event info -->
          <div class="event-info" v-if="liveEvent">
              <live-event-info :event="liveEvent" page="'event'"></live-event-info>
          </div>

          <!-- Prematch event info -->
          <div class="event-info" v-if="!liveEvent">
            <template v-if="event.participantname_away && event.participantname_home">
              <!--<div class="competition-title">{{ event.sportname || event.fosportname }}3</div>-->

              <section v-if="brandLayout !== 'generic' && brandKey !== 'sb' && brandKey !== 'rw'" class="parent">
                <section class="child child-left">
                  <div v-if="isbig3event" class="team-title">{{ event.participantname_away }} <p v-if="isPitcherVisible" class="smaller">{{ event.awaypitchername | lowercase }}</p></div>
                  <div v-else class="team-title">{{ event.participantname_home }} <p v-if="isPitcherVisible" class="smaller">{{ event.homepitchername | lowercase }}</p></div>
                </section>
                <section class="child child-center">
                  <div>
                    <span class="time">{{ event.tsrealstart | moment(dateFormats.longTime) }}</span>
                    <span class="day">{{ event.tsrealstart | moment(dateFormats.dayAndMonth) }}</span>
                  </div>
                </section>
                <section class="child child-right">
                  <div v-if="isbig3event" class="team-title">{{ event.participantname_home }} <p v-if="isPitcherVisible" class="smaller">{{ event.homepitchername | lowercase}}</p></div>
                  <div v-else class="team-title">{{ event.participantname_away }} <p v-if="isPitcherVisible" class="smaller">{{ event.awaypitchername | lowercase}}</p></div>
                </section>
              </section>

              <section v-if="brandLayout === 'generic' || brandKey === 'sb' || brandKey ==='rw'" class="parent">
                <section v-if="isbig3event" class="child child-left">
                  <div class="team-title">{{ event.participantname_away }} <p v-if="isPitcherVisible" class="smaller">{{ event.awaypitchername | lowercase }}</p></div>
                  <div class="team-title">{{ event.participantname_home }} <p v-if="isPitcherVisible" class="smaller">{{ event.homepitchername | lowercase}}</p></div>
                </section>
                <section v-else class="child child-left">
                  <div class="team-title">{{ event.participantname_home }} <p v-if="isPitcherVisible" class="smaller">{{ event.homepitchername | lowercase}}</p></div>
                  <div class="team-title">{{ event.participantname_away }} <p v-if="isPitcherVisible" class="smaller">{{ event.awaypitchername | lowercase }}</p></div>
                </section>
                <section class="child child-right">
                  <div>
                    <span class="day">{{ event.tsrealstart | moment(dateFormats.dayAndMonthUS) }}</span>
                    <span class="time">{{ event.tsrealstart | moment(dateFormats.longTime) }}</span>
                  </div>
                </section>
              </section>
            </template>
            <h3 v-if="!event.participantname_away || !event.participantname_home">{{ event.name }}</h3>
          </div>
        </div>
      </template>
    </template>
    <template v-if="isLiveStreamVisible">
      <template v-if="isLoggedIn">
        <div v-if="!sisStreamData.error" class="video-streaming">
          <!-- <LiveVideoStreaming v-if="isLiveStreamVisible" :livestream="liveStream"></LiveVideoStreaming> -->
          <THEOPlayer :playerLicense="sisStreamData.playerLicense" :src="sisStreamData.hespSrc" :subscriberToken="sisStreamData.subscribeToken"></THEOPlayer>
        </div>
        <div v-else class="video-streaming-error-message">
          <h2>{{ sisStreamData.error ? sisStreamData.error : 'Video stream not available at the moment.' }}</h2>
        </div>
      </template>
      <div v-else class="video-streaming-error-message">
        <h2>Please log in to watch video stream!</h2>
      </div>
    </template>
    <!--  Flash Betting Markets  -->
    <template v-if="isFlashBettingEnabled && liveEvent && liveEvent.mtcgflags && liveEvent.mtcgflags.includes('FlashBetting')">
      <div>
        <FlashBetting :flashBettingMarkets="flashBettingMarkets" :mode="'event'" />
      </div>
    </template>
    <feature-tabs-widget v-if="availableFeatureTabs && availableFeatureTabs.length > 0" :availableFeatureTabs="availableFeatureTabs" :eventId="idfoevent" :displayMode="'carousel'"></feature-tabs-widget>
    <!-- Show Eventmarketgroups in tabs -->
    <xtremepush-inline-content v-if="(xtremepushWebInitialized || xtremePushEnabledMobile) && xtremepushOnSiteEnabled && xtremepushInlineContent" :sportType="event.idfosporttype" :section="'under_coupon_tabs'"></xtremepush-inline-content>
    <div class="v-tabs-wrapper clearfix" :class="{'betradar-id' :betRadarId}">
      <v-tabs :class="['eventmarketgroups-tab', {'have-bet-radar-id':betRadarId }, {'with_more_btn': eventmarketgroups.length > numberOfTabs}]">
        <v-tab :class="['sport', 'tab', {'active': selectedIDFWMarkettypeclassGroup === 'recommended' }]"
               v-if="isRecommendedMarketsEnabled"
               @click.stop="selectEMG('recommended')">{{ $t('Page.Event.RecommendedTab') }}</v-tab>
        <v-tab :class="['sport', 'tab', {'active': eventmarketgroup.idfwmarkettypeclassgroup === selectedIDFWMarkettypeclassGroup }]"
               v-for="(eventmarketgroup, index) in eventmarketgroups" :key="eventmarketgroup.idfwmarkettypeclassgroup"
               v-if="((index <= numberOfTabs - 1 && !mobileBigAndBelow) || (index >= 0 && mobileBigAndBelow)) && eventmarketgroup.name"
               @click.stop="selectEMG(eventmarketgroup.idfwmarkettypeclassgroup)">{{ eventmarketgroup.name }}</v-tab>
        <v-menu offset-y max-width="320" min-width="212" :left="true" :bottom="true" origin="center" content-class="menu_top_arrow_right"
          v-if="(eventmarketgroups.length > numberOfTabs) && !mobileBigAndBelow"
          class="v-tabs__div"
        >
          <a v-if="!mobileBigAndBelow" slot="activator" class="more_tabs" :class="moreButtonState">
            <span>{{ $t('More') }}</span>
            <v-icon v-if="moreButtonState">expand_less</v-icon>
            <v-icon v-else>expand_more</v-icon>
          </a>
          <v-list>
            <v-list-tile
              v-for="(eventmarketgroup, index) in eventmarketgroups"
              v-if="index > numberOfTabs - 1"
              :key="index"
              :class="['sporttab-li', {'active': eventmarketgroup.idfwmarkettypeclassgroup === selectedIDFWMarkettypeclassGroup }]"
              @click.stop="selectEMG(eventmarketgroup.idfwmarkettypeclassgroup)"
            >
              <span class="list_title">{{ eventmarketgroup.name }}</span><icon name="icon-tick" colorName="blue"></icon>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-tabs>
    </div>
    <div v-if="isMarketsOrderOnEventPageEnabled" class='toggle-container'>
      {{ $t('Order.By') }}
      <div class='order-toggle' :style="{ '--active-index': activeIndex }">
        <div v-for="option in marketsOrderOptions" :key="option.value" class='order-toggle__option' :class="{ 'order-toggle__option--active': order === option.value }" @click="setOrder(option.value)">
          {{ option.label }}
        </div>
      </div>
    </div>
    <div class="eventmarketgroup marketgroup" :class="[{'betradar-id' :betRadarId}, className, {'order-toggle-enabled': isMarketsOrderOnEventPageEnabled}]" v-if="selectedEventMarketGroup" :key="selectedEventMarketGroup.idfwmarkettypeclassgroup">
      <template v-if="displayAllGamePeriodsAsBig3">
        <markets :markets="gamePeriodMarkets" v-if="filteredBig3MarketsPerPeriod" v-for="(gamePeriodMarkets, key) in filteredBig3MarketsPerPeriod" :key="key"
                 :event="event"
                 :diplayOnPage="'live-single-event'"
                 :isLiveEventPage="isLiveEventPage"
                 :pricechangehighlight="isLiveEventPage"></markets>
      </template>
      <template v-else>
        <markets :markets="filteredBig3MarketsWholeGame" v-if="filteredBig3MarketsWholeGame"
                 :event="event"
                 :diplayOnPage="'live-single-event'"
                 :isLiveEventPage="isLiveEventPage"
                 :pricechangehighlight="isLiveEventPage"></markets>
      </template>
      <div :style="{ order: market.order }" :class="['event-market-header',{'last': index === filteredNonBig3NonAltMarkets.length - 1}, {'available-for-bb': isBBenabled &&market.BB}]" v-for="(market, index) in filteredNonBig3NonAltMarkets" :key="index">
        <div class="market-name" :class="[{'expanded-market': expandedMarkets[selectedEventMarketGroup.idfwmarkettypeclassgroup + '-' + market.idfomarket]  && market.order !== 0 || expandedMarkets[selectedEventMarketGroup.idfwmarkettypeclassgroup + '-' + market.idfomarket] !== false && market.order === 0}]" @click.stop="toggleExpandMarket(selectedEventMarketGroup.idfwmarkettypeclassgroup + '-' + market.idfomarket, market.order, market.idfomarket)">
          <h4 class="market-name-title">{{ market.name}}</h4>
          <span class="flex icon-span">
            <sgp-tag :markets="ksPreProcessMarkets([market], event)" :isLive="isLiveEventPage"></sgp-tag>
            <span v-if="isBBenabled && market.BB" class="available-for-bb"></span>
             <v-icon>{{ market.idfomarket === firstMarketKey ? 'expand_less' : 'expand_more' }}</v-icon>
          </span>
        </div>
        <markets :markets="[market]" v-if="(market.order === 0 && expandedMarkets[selectedEventMarketGroup.idfwmarkettypeclassgroup + '-' + market.idfomarket] !== false) ||
          expandedMarkets[selectedEventMarketGroup.idfwmarkettypeclassgroup + '-' + market.idfomarket]"
          :event="event"
          :diplayOnPage="'live-single-event'"
          :isLiveEventPage="isLiveEventPage"
          :pricechangehighlight="isLiveEventPage"></markets>
      </div>
      <div class="event-market-header alt-markets" :style="{ order: group.order }" v-for="(group, index) in groupAltMarkets">
        <alt-markets
          :markets="group.markets"
          :event="event"
          :diplayOnPage="'live-single-event'"
          :isLiveEventPage="isLiveEventPage"
          :pricechangehighlight="isLiveEventPage"
          :expandFirst="group.order === 0">
        </alt-markets>
      </div>
      <player-props-markets
        :markets="filteredNonBig3PlayerPropsMarkets"
        :event="event"
        :diplayOnPage="'live-single-event'"
        :isLiveEventPage="isLiveEventPage"
        :pricechangehighlight="isLiveEventPage"
        :expandFirst="!filteredNonBig3NonPlayerPropsMarkets.length">
      </player-props-markets>
    </div>
    <div v-if="!marketsAvailable && !isRecommendedMarketsLoading" class="no-markets">
      {{ $t('Sports.NoAvailableMarkets') }}
    </div>
  </v-container>
</template>
<script>
  import Vue from 'vue'
  import axios from 'axios'
  import store from '@/store'
  import lib from '@/library'
  import config from '@/config'
  import originLib from '@/library/origin'

  import markets from '@/components/sports/bettingoffer/markets'
  import betRadarWidget from '@/components/sports/bettingoffer/betRadarWidget'
  import BetRadarWidgetV2 from '@/components/sports/bettingoffer/betRadarWidgetv2'
  import LiveVideoStreaming from '@/components/sports/bettingoffer/live/LiveVideoStreaming'
  import LiveEventInfo from '@/components/sports/bettingoffer/live/liveEventInfo'
  import sgpTag from '@/components/sports/betslipV2/common/marketSgpTag'
  import XtremepushInlineContent from '@/components/layout/parts/XtremepusInlineContent'
  import PlayerPropsMarkets from '@/components/sports/bettingoffer/PlayerPropsMarkets'
  import BettingOffer from '@/components/mixins/BettingOffer'
  import Screen from '@/components/mixins/Screen'
  import Branding from '@/components/mixins/Branding'
  import Icon from '@/components/common/Icon'
  import killswitch from '@/components/mixins/killswitch'

  import { localeProperties } from '@/library/locale/i18n'
  import momentLocale from 'moment/min/locales'
  import moment from 'moment'
  import PopularParlays from '@/components/sports/bettingoffer/popularParlays/PopularParlays'
  import PlayerPropsWidget from '@/components/sports/bettingoffer/playerPropsWidget/PlayerPropsWidgetComponent.vue'
  import FlashBetting from '@/components/sports/bettingoffer/FlashBetting.vue'
  import AltMarkets from '@/components/sports/bettingoffer/AltMarkets'
  import bettingDataMatcher from '@/library/bettingDataMatcher'
  import sisStreaming from '@/library/sisStreaming'
  import THEOPlayer from '@/components/sports/bettingoffer/live/THEOPlayer'
  import orderBy from 'lodash/orderBy'
  import featureTabsWidget from '@/components/sports/bettingoffer/featureTabsWidget/featureTabsWidget.vue'

  export default {
    name: 'event',

    components: {
      markets,
      LiveEventInfo,
      betRadarWidget,
      Icon,
      LiveVideoStreaming,
      BetRadarWidgetV2,
      sgpTag,
      XtremepushInlineContent,
      PlayerPropsMarkets,
      PopularParlays,
      FlashBetting,
      AltMarkets,
      THEOPlayer,
      PlayerPropsWidget,
      featureTabsWidget
    },

    mixins: [
      BettingOffer,
      Branding,
      Screen,
      killswitch
    ],

    data () {
      return {
        periodicalUpdateTimeout: undefined,
        prematchPeriodicalUpdateInterval: config.app.udpateIntervals.prematchPeriodicalUpdateInterval,
        livePeriodicalUpdateInterval: config.app.udpateIntervals.livePeriodicalUpdateInterval,
        isPeriodicalUpdateStarted: false,
        selectedIDFWMarkettypeclassGroup: 0,
        collapsed: true,
        expandedMarkets: {},
        isLiveStreamVisible: false,
        isbig3event: false,
        betradarIdFromBettingDataMatcher: null,
        bettingDataMatcherinitiallLoad: false,
        updateRecommendedMarketsInterval: null,
        sisMappings: [],
        sisStreamData: {},
        order: 'DEFAULT',
        userSelectedOrderPerEvent: false,
        userSelectedOrderPerTab: {},
        lastTabId: ''
      }
    },

    metaInfo () {
      return {
        title: this.metaTitle,
        meta: [{
          description: this.metaDescription,
          keywords: this.metaKeywords
        }]
      }
    },

    computed: {
      firstMarketKey () {
        const allMarkets = [...this.filteredNonBig3NonAltMarkets]
        this.groupAltMarkets.forEach(group => allMarkets.push(...group.markets))
        if (allMarkets.length > 0) {
          return allMarkets[0].idfomarket
        }
        return null
      },
      className () {
        if (this.selectedEventMarketGroup && this.selectedEventMarketGroup.idfwmarkettypeclassgroup === 'recommended') return originLib.config.vaix.nameId
        return ''
      },
      isBBenabled () {
        return config.app.autoconf.IS_BUYBACK_ENABLED
      },
      currentLocale () {
        return localeProperties.getCurrentLocale
      },
      metaTitle () {
        if (this.event && this.event.name) {
          return `${this.event.name} - ${this.$t('Page.Meta.Title')}`
        } else {
          return this.$t('Page.Meta.Title')
        }
      },
      metaDescription () {
        return this.$t('Page.Meta.Description')
      },
      metaKeywords () {
        return this.$t('Page.Meta.Keywords')
      },
      idfoevent () {
        var idfoevent = this.$route.params.idfoevent && this.$route.params.idfoevent.toString()
        if (idfoevent && idfoevent.indexOf('.') === -1) {
          idfoevent += '.1'
        }

        return idfoevent
      },
      isBetradarWidgetEnabledForEvent () {
        return window.ctsautoconf.BR_WIDGET_ENABLED && window.ctsautoconf.BR_WIDGET_CLIENTID &&
          (window.ctsautoconf.BR_WIDGET_SPORTS.length === 0 || window.ctsautoconf.BR_WIDGET_SPORTS.indexOf(this.event.idfosporttype) > -1)
      },
      betRadarId () {
        // return 23916139
        if (this.isBetradarWidgetEnabledForEvent) {
          // If there is data from betting data matcher service use it
          if (this.betradarIdFromBettingDataMatcher) return this.betradarIdFromBettingDataMatcher

          if (this.event && this.event.idefevent) {
            let provider = this.event.idefevent.split('|')[0]
            if (provider && provider.indexOf('BETRADAR') > -1) {
              let rawBetradarid = this.event.idefevent.split('|')[1]
              if (rawBetradarid) {
                return rawBetradarid.indexOf('_') > -1 ? rawBetradarid.split('_')[1] : rawBetradarid
              }
            } else {
              return (this.event && this.event.origin) || undefined
            }
          } else {
            return (this.event && this.event.origin) || undefined
          }
        }
      },
      event () {
        return store.getters['eventState/getEvent']
      },
      liveEvent () {
        var self = this
        return this.liveEvents.find(ev => ev.idfoevent.toString() === self.idfoevent.toString() || (ev.foeventantepost && ev.foeventantepost.toString() === self.idfoevent.toString()))
      },
      eventmarketgroups () {
        if (this.event && Array.isArray(this.event.eventmarketgroups)) {
          return Vue._.orderBy(this.event.eventmarketgroups, 'internalorder', 'asc')
        }
        return []
      },

      selectedEventMarketGroup () {
        if (this.isRecommendedMarketsEnabled && this.selectedIDFWMarkettypeclassGroup === 'recommended') {
          return this.recommendedMarketsEventMarketGroup
        }

        if (Array.isArray(this.eventmarketgroups) && this.eventmarketgroups.length > 0) {
          return this.eventmarketgroups.find(emg => emg.idfwmarkettypeclassgroup === this.selectedIDFWMarkettypeclassGroup) || null
        }

        return null
      },
      filteredBig3MarketsWholeGame () {
        return (this.selectedEventMarketGroup &&
                  this.selectedEventMarketGroup.markets &&
                  this.selectedEventMarketGroup.markets[0] &&
                  config.app.autoconf.BIG3_IGNORE_SPORTTYPES.indexOf(this.selectedEventMarketGroup.markets[0].idfosporttype) === -1 &&
                  this.selectedEventMarketGroup.markets.filter(mk => mk.big3markettype && mk.gameperiod === '1+' && mk.selections && mk.selections.length <= 2)) || []
      },
      filteredBig3MarketsPerPeriod () {
        var markets = (this.selectedEventMarketGroup &&
          this.selectedEventMarketGroup.markets &&
          this.selectedEventMarketGroup.markets[0] &&
          config.app.autoconf.BIG3_IGNORE_SPORTTYPES.indexOf(this.selectedEventMarketGroup.markets[0].idfosporttype) === -1 &&
          this.selectedEventMarketGroup.markets.filter(mk => mk.big3markettype && mk.selections && mk.selections.length <= 2)) || []

        var marketsPerPeriod = Vue._.groupBy(markets, 'gameperiodname')
        return marketsPerPeriod
      },

      filteredNonBig3Markets () {
        var big3Markets = []

        if (this.displayAllGamePeriodsAsBig3) {
          for (let key in this.filteredBig3MarketsPerPeriod) {
            if (this.filteredBig3MarketsPerPeriod[key] && this.filteredBig3MarketsPerPeriod[key].length > 0) {
              big3Markets = big3Markets.concat(this.filteredBig3MarketsPerPeriod[key])
            }
          }
        } else {
          big3Markets = this.filteredBig3MarketsWholeGame
        }

        const markets =
          this.selectedEventMarketGroup &&
          this.selectedEventMarketGroup.markets
            ? this.selectedEventMarketGroup.markets.filter(mk => {
              if (!big3Markets || big3Markets.length === 0) return true
              return big3Markets.filter(b3mk => b3mk.idfomarket === mk.idfomarket).length === 0
            })
            : []

        let sortedMarkets = markets

        const toNaturalKey = (str) => {
          if (!str) return ''
          return String(str).replace(/\d+/g, (m) => m.padStart(6, '0'))
        }

        if (this.order === 'MARKETNAMEASC') {
          sortedMarkets = orderBy(sortedMarkets, [mk => toNaturalKey(mk.name)], ['asc'])
        }

        return sortedMarkets.map((market, index) => ({
          ...market,
          order: index
        }))
      },
      filteredNonBig3NonPlayerPropsMarkets () {
        return (Array.isArray(this.filteredNonBig3Markets) ? this.filteredNonBig3Markets : [])
          .filter((mk) => !this.isPlayerPropsMarket(mk))
      },
      filteredNonBig3PlayerPropsMarkets () {
        return (Array.isArray(this.filteredNonBig3Markets) ? this.filteredNonBig3Markets : [])
          .filter((mk) => this.isPlayerPropsMarket(mk))
      },
      filteredNonBig3NonAltMarkets () {
        const markets = Array.isArray(this.filteredNonBig3NonPlayerPropsMarkets) ? this.filteredNonBig3NonPlayerPropsMarkets : []
        const altKeys = this.getAltMarketKeys(markets)

        return markets.filter(mk => {
          const key = `${mk.name}-${mk.idfomarkettype}`

          return !altKeys.has(key)
        })
      },

      filteredNonBig3AltMarkets () {
        const markets = Array.isArray(this.filteredNonBig3Markets) ? this.filteredNonBig3Markets : []
        const altKeys = this.getAltMarketKeys(markets)

        return markets.filter(mk => {
          const key = `${mk.name}-${mk.idfomarkettype}`

          return altKeys.has(key)
        })
      },
      isLiveEventPage () {
        return this.liveEvent !== undefined
      },
      moreButtonState () {
        var linksInMoreTab = []
        for (var i = 0; i < this.eventmarketgroups.length; i++) {
          if (i > 4 && (this.selectedIDFWMarkettypeclassGroup === this.eventmarketgroups[i].idfwmarkettypeclassgroup)) {
            linksInMoreTab.push(i)
          }
        }
        if (linksInMoreTab.length > 0) {
          return 'active'
        }
      },
      liveStreams () {
        return store.getters['livebettingState/liveStreams']
      },
      liveStream () {
        return this.liveStreams && this.liveStreams.find(ls => ls.idfoevent === this.event.idfoevent)
      },
      isLoggedIn () {
        return store.getters['isLoggedIn']
      },
      isPitcherVisible () {
        return !config.app.autoconf.HIDE_PITCHER_NAME
      },
      displayAllGamePeriodsAsBig3 () {
        return config.app.autoconf.DISPLAY_ALL_GAMEPERIODS_AS_BIG3
      },
      liveWireLiveEventsSubscribeCounter () {
        return store.getters['livebettingState/getLiveWireLiveEventsSubscribeCounter']
      },
      betRadarWidgetVersion () {
        return window.ctsautoconf.BR_WIDGET_VERSION || 'V2'
      },
      xtremepushWebInitialized () {
        return store.getters['getXtremepushWebInitialized']
      },
      xtremepushOnSiteEnabled () {
        return config.app.autoconf.XTREMEPUSH_ANALYTICS && config.app.autoconf.XTREMEPUSH_ANALYTICS.CHANNEL && config.app.autoconf.XTREMEPUSH_ANALYTICS.CHANNEL.ON_SITE
      },
      xtremePushEnabledMobile () {
        return config.app.autoconf.XTREMEPUSH_ANALYTICS && config.app.autoconf.XTREMEPUSH_ANALYTICS.MOBILE_APP // for mobile apps only
      },
      xtremepushInlineContent () {
        return store.getters['getXtremepushInlineContent']
      },
      isRecommendedMarketsEnabled () {
        return config.app.autoconf.PLAYER_PERSONALISATION.enableRecommendedMarkets
      },
      isRecommendedTabDefaultOnEventPage () {
        return config.app.autoconf.PLAYER_PERSONALISATION.isRecommendedTabDefaultOnEventPage
      },
      isRecommendedMarketsLoading () {
        return store.getters['vaixTabsState/getRecommendedMarketsLoading']
      },
      isRecommendedTabSelected () {
        return this.selectedIDFWMarkettypeclassGroup === 'recommended'
      },
      recommendedMarketsEventMarketGroup () {
        if (!this.isRecommendedMarketsEnabled) return null

        const recommendedGroupFromStore =
          store.getters['vaixTabsState/getRecommendedMarketsEventMarketGroup']

        if (!recommendedGroupFromStore || typeof recommendedGroupFromStore !== 'object') {
          return null
        }

        const normalizedRecommendedMarketGroup = {
          ...recommendedGroupFromStore,
          name: this.$t('Page.Event.RecommendedTab'),
          markets: Array.isArray(recommendedGroupFromStore.markets)
            ? Vue._.orderBy(recommendedGroupFromStore.markets, 'internalorder', 'asc')
            : []
        }

        // If recommended markets are enabled but empty, fallback to the first regular event market group.
        if (Array.isArray(normalizedRecommendedMarketGroup.markets) &&
          normalizedRecommendedMarketGroup.markets.length === 0 &&
          !this.isRecommendedMarketsLoading &&
          Array.isArray(this.eventmarketgroups) &&
          this.eventmarketgroups.length > 0
        ) {
          return this.eventmarketgroups[0] || null
        }

        return normalizedRecommendedMarketGroup
      },
      periodicalUpdateRecommendedMarkets () {
        return config.app.autoconf.PLAYER_PERSONALISATION.periodicalUpdateRecommendedMarkets
      },
      showPopularParlaysOnEventPage () {
        return config.app.autoconf.PLAYER_PERSONALISATION.showPopularParlaysOnEventPage &&
          config.app.autoconf.PLAYER_PERSONALISATION.enablePopularParlays
      },
      marketsAvailable () {
        return this.selectedEventMarketGroup && this.selectedEventMarketGroup.markets && this.selectedEventMarketGroup.markets.length
      },
      isFlashBettingEnabled () {
        return config.app.autoconf.FLASH_BETTING.enableFlashBettingMarkets
      },
      flashBettingMarkets () {
        if (!this.liveEvent || !this.liveEvent.markets) {
          return []
        }
        return this.liveEvent.markets.filter(market => {
          const isFlashBetting = market.mtcgflag && market.mtcgflag.includes('FlashBetting')
          const isTradable = market.istradable
          const hasOnlyTwoSelections = Array.isArray(market.selections) && market.selections.length === 2
          const hasPrice = hasOnlyTwoSelections && market.selections.every(sel => sel.price !== undefined && sel.price !== null)
          const hasSuspensionTypeNO = hasOnlyTwoSelections && market.selections.some(sel => sel.idfoselectionsuspensiontype === 'N/O')

          return isFlashBetting && isTradable && hasOnlyTwoSelections && hasPrice && !hasSuspensionTypeNO
        })
      },
      isEventStreamable () {
        if (!this.idfoevent) return false
        if (!this.sisMappings || !(this.sisMappings.length > 0)) return false
        return this.sisMappings.some(item => Number(item.idFoEvent) === Number(this.idfoevent))
      },
      sisStreamId () {
        if (!this.isEventStreamable) return ''
        const event = this.sisMappings.find(item => Number(item.idFoEvent) === Number(this.idfoevent))
        for (const mapping of event.mappings || []) {
          const streamContent = (mapping.contents || []).find(c => c.type === 'STREAM')
          if (streamContent) {
            return streamContent.content
          }
        }
        return ''
      },
      uid () {
        return store.getters['getUid'] || localStorage.getItem('customer')
      },
      isSisVideoStreamingEnabled () {
        return config.app.autoconf.SIS_VIDEO_STREAMING_ENABLED
      },
      groupAltMarkets () {
        const groupedAltMarkets = {}

        if (!Array.isArray(this.filteredNonBig3AltMarkets)) return []

        this.filteredNonBig3AltMarkets.forEach(market => {
          if (!market || typeof market !== 'object' || !market.name) return

          const key = String(market.name).trim()
          if (!key) return

          if (!groupedAltMarkets[key]) {
            groupedAltMarkets[key] = {
              name: key,
              order: null,
              markets: []
            }
          }

          groupedAltMarkets[key].markets.push(market)

          const ord = market.order !== null && market.order !== undefined
            ? Number(market.order)
            : null

          if (ord === null || Number.isNaN(ord)) return

          if (groupedAltMarkets[key].order === null || ord < groupedAltMarkets[key].order) {
            groupedAltMarkets[key].order = ord
          }
        })

        Object.values(groupedAltMarkets).forEach(group => {
          group.markets.sort((a, b) => {
            const handicapA =
              a.currentmatchhandicap !== null && a.currentmatchhandicap !== undefined
                ? Number(a.currentmatchhandicap)
                : -Infinity

            const handicapB =
              b.currentmatchhandicap !== null && b.currentmatchhandicap !== undefined
                ? Number(b.currentmatchhandicap)
                : -Infinity

            return handicapB - handicapA
          })
        })

        return Object.values(groupedAltMarkets).sort((a, b) => {
          const oa = a.order !== null && a.order !== undefined ? Number(a.order) : 999999
          const ob = b.order !== null && b.order !== undefined ? Number(b.order) : 999999
          return oa - ob
        })
      },
      isMarketsOrderOnEventPageEnabled () {
        return config.app.autoconf.MARKETS_ORDER_ON_EVENT_PAGE.enable
      },
      marketsOrderOptions () {
        return config.app.autoconf.MARKETS_ORDER_ON_EVENT_PAGE.orderOptions
      },
      activeIndex () {
        const idx = this.marketsOrderOptions.findIndex(opt => opt.value === this.order)
        return idx > -1 ? idx : 0
      },

      saveUserPreferencePerEvent () {
        return config.app.autoconf.MARKETS_ORDER_ON_EVENT_PAGE.saveUserPreferencePerEvent
      },
      saveUserPreferencePerTab () {
        return config.app.autoconf.MARKETS_ORDER_ON_EVENT_PAGE.saveUserPreferencePerTab
      },
      activeTabId () {
        const group = this.selectedEventMarketGroup
        return group && group.idfwmarkettypeclassgroup != null
          ? String(group.idfwmarkettypeclassgroup)
          : ''
      },
      isPlayerPropsWidgetEnabledAndShowOnEventPage () {
        return config.app.autoconf.PLAYER_PERSONALISATION.PLAYER_PROPS_WIDGET && config.app.autoconf.PLAYER_PERSONALISATION.PLAYER_PROPS_WIDGET.enabled && config.app.autoconf.PLAYER_PERSONALISATION.PLAYER_PROPS_WIDGET.on_event_page
      },
      availableFeatureTabs () {
        const tabs = config.app.autoconf.FEATURES_TABS
        if (!tabs) return []
        return Object.entries(tabs).sort(([, a], [, b]) => a.order - b.order).filter(([, tab]) => tab.enabled && tab.showOnEvent).map(([key]) => key)
      },
      isFastSwitchEnabled () {
        return config.app.autoconf.FAST_SWITCH
      },
      fastSwitchDialog () {
        return store.getters['overlayState/getFastSwitchDialog']
      },
      idFwMarketgroup () {
        return this.$route.query.idfwmarketgroup
      }
    },

    methods: {
      setOrder (val) {
        if (this.order === val) return

        if (this.saveUserPreferencePerEvent) {
          this.userSelectedOrderPerEvent = true
        }

        if (this.saveUserPreferencePerTab && this.activeTabId) {
          this.$set(this.userSelectedOrderPerTab, this.activeTabId, true)
          this.lastTabId = this.activeTabId
        }

        this.order = val
      },
      isBig3 () {
        let isNonBig3FoSportType = config.app.autoconf.BIG3_IGNORE_SPORTTYPES.includes(this.event.idfosporttype)
        if (!isNonBig3FoSportType) {
          let breakLoop = false
          this.eventmarketgroups.forEach(marketgroup => {
            if (breakLoop) return false
            // console.log('first loop')
            marketgroup.markets.forEach(market => {
              if (breakLoop) return false
              // console.log(market, 'market')
              if (market.big3markettype && (market.gameperiod === '1+' || this.displayAllGamePeriodsAsBig3)) {
                // console.log(market.gameperiod + ' ' + market.big3markettype)
                this.isbig3event = true
                breakLoop = true
              }
            })
          })
        }
      },
      toggleExpandMarket (id, index, idfomarket) {
        if (index === 0 && this.expandedMarkets[id] === undefined) {
          Vue.set(this.expandedMarkets, id, false)
        } else {
          Vue.set(this.expandedMarkets, id, !this.expandedMarkets[id])
        }
      },
      startEventByIdUpdate (idfoevent) {
        this.isPeriodicalUpdateStarted = true
        clearTimeout(this.periodicalUpdateTimeout)
        this.fetchEventDataFromBettingDataMatcher(idfoevent)
        store.dispatch('eventState/fetchEventById', { idfoevent: idfoevent, isliveevent: this.isLiveEventPage }).then(() => {
          this.periodicalUpdateTimeout = setTimeout(() => {
            if (this.isPeriodicalUpdateStarted) {
              this.startEventByIdUpdate(idfoevent)
            }
          }, this.isLiveEventPage ? this.livePeriodicalUpdateInterval : this.prematchPeriodicalUpdateInterval)
        })
        if (this.isRecommendedMarketsEnabled) {
          store.dispatch('vaixTabsState/fetchRecommendedMarkets', idfoevent)
        }
      },
      stopEventByIdUpdate () {
        this.isPeriodicalUpdateStarted = false
        clearTimeout(this.periodicalUpdateTimeout)
      },
      clearCachedEvents () {
        store.dispatch('eventState/clearCachedEvent')
      },
      selectEMG (idfwmarkettypeclassgroup) {
        this.selectedIDFWMarkettypeclassGroup = idfwmarkettypeclassgroup
        if (this.selectedIDFWMarkettypeclassGroup === 'recommended') {
          this.sendGTMRecommendedTab(true, 'markets')
        }
      },
      subscribeToLiveEventMarkets () {
        if (this.idfoevent) {
          lib.WebSocketLiveService.subscribeToEventPageMarkets(this.idfoevent)
        }
      },
      unsubscribeFromLiveEventMarkets () {
        lib.WebSocketLiveService.unsubscribeFromEventPageMarkets()
      },
      showLiveStream () {
        this.isLiveStreamVisible = true
      },
      showEventInfo () {
        this.isLiveStreamVisible = false
      },
      fetchEventDataFromBettingDataMatcher (idfoevent) {
        let contentHost = config.app.autoconf.BETTING_DATA_MATCHER_SERVICE_HOSTNAME

        if (!config.app.autoconf.BETTING_DATA_MATCHER) {
          this.bettingDataMatcherinitiallLoad = true
          return
        }

        axios.get(`${contentHost}/bettingMatcher/api/v1/eventContent?idFoEvent=${this.idfoevent}`).then((response) => {
          if (response && response.data && response.data.length && response.data[0].idFoEvent.toString() === this.idfoevent.toString() && response.data[0].mappings && response.data[0].mappings.length) {
            let data = response.data[0]
            let widget = data.mappings.find((wdg) => {
              let sportradar = (wdg.dataSource === 'SPORTRADAR')
              let lmt = wdg.contents.some((cnt) => cnt.type === 'LMT')
              // Find the one that has data source SPORTRADAR and in contents has one with LMT type
              return sportradar && lmt
            })

            if (widget && widget.event) {
              let betradarId = widget.event.split(':').pop()
              this.betradarIdFromBettingDataMatcher = betradarId
            }
          }
        }).catch((err) => {
          console.log(err)
        }).finally(() => {
          this.bettingDataMatcherinitiallLoad = true
        })
      },
      getAltMarketKeys (markets) {
        const map = markets.reduce((acc, mk) => {
          const key = `${mk.name}-${mk.idfomarkettype}`
          acc[key] = (acc[key] || 0) + 1
          return acc
        }, {})

        return new Set(Object.keys(map).filter(k => map[k] > 1))
      },
      toggleFastSwitch () {
        if (this.fastSwitchDialog) {
          store.dispatch('overlayState/deactivateFastSwitchDialog')
        } else {
          store.dispatch('overlayState/activateFastSwitchDialog')
        }
      }
      // preselectNav (liveEventPage) {
      //   setTimeout(() => {
      //     if (liveEventPage) {
      //       let mainNav = document.querySelector('.main-navigation [href="/live"]')
      //       document.querySelector('.main-navigation .router-link-active').classList.remove('router-link-exact-active', 'router-link-active')
      //       mainNav.classList.add('router-link-exact-active', 'router-link-active')
      //     } else {
      //       let mainNav = document.querySelector('.main-navigation [href="/sports"]')
      //       document.querySelector('.main-navigation [href="/live"]').classList.remove('router-link-exact-active', 'router-link-active')
      //       mainNav.classList.add('router-link-exact-active', 'router-link-active')
      //     }
      //   }, 0)
      // }
    },
    created () {
      moment.updateLocale(this.currentLocale, momentLocale)
      this.clearCachedEvents()
      this.startEventByIdUpdate(this.idfoevent)

      if (this.isLiveEventPage) {
        // this.preselectNav(this.isLiveEventPage)
        this.subscribeToLiveEventMarkets()
      }
    },
    async mounted () {
      if (this.isSisVideoStreamingEnabled) {
        this.sisMappings = await bettingDataMatcher.fetchEventContent({idFoEvent: this.idfoevent, contentType: 'STREAM', dataSource: 'SIS'})
        if (this.isEventStreamable) {
          this.sisStreamData = await sisStreaming.fetchStreamData({customer: '7NWEHtYo', streamId: this.sisStreamId, username: this.uid})
        }
      }
    },

    destroyed () {
      // this.preselectNav(false)
      this.clearCachedEvents()
      this.stopEventByIdUpdate()
      this.unsubscribeFromLiveEventMarkets()
      this.bettingDataMatcherinitiallLoad = false
      this.betradarIdFromBettingDataMatcher = null
    },

    watch: {
      idfoevent () {
        this.clearCachedEvents()
        this.startEventByIdUpdate(this.idfoevent)
        this.selectedIDFWMarkettypeclassGroup = 0
      },
      isLiveEventPage (newVal) {
        if (newVal) {
          this.startEventByIdUpdate(this.idfoevent)
          this.subscribeToLiveEventMarkets()
        }
      },
      liveWireLiveEventsSubscribeCounter () {
        this.subscribeToLiveEventMarkets()
      },
      isLoggedIn (newVal) {
        // if user logs in when on livestream, livestream will switch to event info
        if (newVal && this.isLiveStreamVisible) {
          this.showEventInfo()
        }
      },
      event (newVal) {
        if (newVal) {
          this.isBig3()
        }
      },
      selectedEventMarketGroup: {
        immediate: true,
        handler (group) {
          // Guard: during API/store refresh the group can be temporarily null.
          if (!group) return

          // SERVER-ONLY MODE:
          // If both perEvent and perTab are false, the server is the single source of truth.
          if (!this.saveUserPreferencePerEvent && !this.saveUserPreferencePerTab) {
            const pref = group.sortpreference ? group.sortpreference : 'DEFAULT'
            this.order = pref
            return
          }

          const currentTabId = this.activeTabId

          // PER-TAB BEHAVIOR:
          // User preference is valid only while the user stays on the same tab.
          if (this.saveUserPreferencePerTab) {
            if (this.lastTabId && this.lastTabId !== currentTabId) {
              if (this.userSelectedOrderPerTab[this.lastTabId]) {
                this.$delete(this.userSelectedOrderPerTab, this.lastTabId)
              }
            }
            this.lastTabId = currentTabId
          }

          // PER-EVENT LOCK:
          // If the user already selected an order for this event, do not override it.
          if (this.saveUserPreferencePerEvent && this.userSelectedOrderPerEvent) return

          // PER-TAB LOCK:
          // If the user selected an order on the current tab, keep it until the tab changes.
          if (this.saveUserPreferencePerTab && currentTabId && this.userSelectedOrderPerTab[currentTabId]) {
            return
          }

          // FALLBACK:
          // Apply server preference if no user lock is active.
          const pref = group.sortpreference ? group.sortpreference : 'DEFAULT'
          this.order = pref
        }
      },
      eventmarketgroups: {
        immediate: true,
        handler (groups) {
          if (this.selectedIDFWMarkettypeclassGroup !== 0) return
          if (!Array.isArray(groups) || !groups.length) return

          this.selectedIDFWMarkettypeclassGroup =
            this.isRecommendedMarketsEnabled && this.isRecommendedTabDefaultOnEventPage
              ? 'recommended'
              : groups[0].idfwmarkettypeclassgroup
        }
      }
    },
    beforeDestroy () {
      store.commit('vaixTabsState/setRecommendedMarketsEventMarketGroup', [])
      store.commit('vaixTabsState/setRecommendedMarketsLoading', true)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>

  @import "~@/css/config.styl"


  .competition-title
    font-size 14px
    opacity .6
    color #fff
    text-align left
    margin-left 20px


  .eventmarketgroups-tab.have-bet-radar-id
    /*border 1px solid red*/
    margin-top: 84px
    /*z-index: 1*/

   .sr-lmt-plus-lmtpitch {
     margin-top 95px
   }

   .sr-lmt__content.srt-base-1 {
     margin-top 97px
   }

  .competition-live.pre-match {
    margin: 0
  }

  .competition-live.live-match {
    margin-top 0px
  }

  .competition-live {
    display: flex
    justify-content: space-between
    margin-top 49px
  }

  .competition-name.competitionname-betradar-id {
    display none
  }
  #app .team-title {
    padding-left 0px
  }

  .live-event {
    margin-right 0px
  }

  .live-event div {
    margin-right: 5px
    font-size 14px
    color:#FFFFFF
    background-color: #DB3F3F
    border-radius: 5px
    line-height: 26px;
    padding: 0px 15px;
  }

  .eventmarketgroups-tab.have-bet-radar-id {
    margin-top  0
    }

  .event
    position relative
    .competition-name
      font-size 18px
      color rgba(255, 255, 255, .9)
      text-align left
      line-height 14px
      cursor default
      font-weight 100
      div
        padding-top 6px
    .event-info
      height 125px
      cursor default
      margin-bottom 4px
      @media mobile-big-and-below
        height auto

  >>>.v-tabs__bar
    .tabs__wrapper
      .v-tabs__container
        height 66px !important

  .more_tabs
    background: #fff
    border-radius: 5px
    text-align: center
    padding: 8px 16px
    height: 36px
    color: #0b4da1
    display: flex
    margin-left: 90px
    margin-right: 12px
    .v-icon
      display block !important
      color #0b4da1
    span
      font-size: 14px
      line-height: 25px
      display: block !important
      color: #0b4da1

  .more_tabs.active
    background: #fff
    .v-icon
      color #0b4da1 !important
  .v-menu__activator--active .more_tabs
    background: #fff
  .list
    padding: 0
    font-size: 14px
    color: #0b4da1 !important
    border-radius: 4px !important
  .list:hover
      border-radius: 4px !important

    .sporttab-li:hover
      border-radius: 4px

    >>>.v-list__tile
      color: #0b4da1
      font-size: 14px
      &:hover
        color: #2396FC
        background: #fff !important
    .list_title
      flex: 1 1 auto

    .sporttab-li .igt-icon
        margin-left: auto
        visibility: hidden

    .sporttab-li.active
      >>>.v-list__tile
        font-weight: bold
        background: #fff !important
    .no-markets
      text-align: center
      padding: 40px
      background: var(--coupon-bgr)
      color: var(--coupon-text-color)
      font-size: 24px
      line-height normal
      font-family "Roboto Condensed Bold"
    .loader
      margin-top 100px
@media mobile-big-and-below
        height: 266px
      .parent
        display flex
        flex-flow row nowrap
        height 100%
        /*padding-top 20px*/
        .child
          width 49%
          height 40%
          color white
          font-size 20px
          line-height 23px
          .team-title
            color white
            line-height 23px
            margin-bottom: 10px
            padding-left 20px
          .smaller
            font-size 12px
            text-transform capitalize
        .child-left
          text-align left
          .team-title
            font-size 20px
        .child-right
          font-size 28px
          text-align right
          padding-top 5px
          .day
            display block
            font-size 14px
    .eventmarketgroup
      padding-top 5px

  .eventmarketgroup-name
    cursor: pointer;
    border: solid 1px #ccc;
    padding: 8px;

  .tab
    border: solid 1px #999;
    padding: 5px;
    margin: 5px;
    cursor: pointer;

  .time-period
    color #828282
    font-size 20px
    line-height 23px
    margin-bottom 0

  .result-title
    color #4F4F4F
    font-size 32px
    line-height 38px
    margin-bottom 5px

  .live-details
    font-family Arial
    font-weight bold
    color #000
    font-size 10px
    line-height 12px
    display block
    text-align center
    cursor pointer

  .live-data
    background-color #4F4F4F
    color #fff
    width 100%
    height 200px
    text-align center
    line-height 200px

  .competition-name
    /*display block*/
    font-family Arial
    font-weight bold
    color #828282
    font-size 14px
    line-height 16px

   @media mobile-big-and-below
    .team-title
      font-size 14px
      line-height 16px
    .time-period
      color #828282
      font-size 14px
      line-height 16px

    .result-title
      font-size 20px
      line-height 23px
      margin-bottom 0

    .live-details
      display none

    .competition-name.competitionname-betradar-id
      display none

    .competition-live
      margin-top: 0

    .live-event
      border-radius 4px
      font-size 12px

    .event .event-info
      margin-bottom 1px


    .eventmarketgroup
      display block
      width 100%
      background #e6e8ed

@media mobile-big-and-below
  >>>.v-tabs__bar .v-tabs__wrapper .v-tabs__container {
    height 48px !important
  }
  .time {
    font-size 14px
  }
  .day {
    font-size 14px
  }

  .competition-live.pre-match {
    margin: 0
  }

  .competition-live.live-match {
    margin: 0
  }

  .event-info {
    margin-bottom: 50px
  }

  .competition-title {
    text-align: left
    margin-left: 20px
  }
  .event .competition-name {
    font-size 14px
  }

  #app .team-title {
    padding-left 20px
    font-size 14px
    }

  .child.child-right {
    /*margin-top: 0px*/
    padding-top: 0px
  }

  .live-event {
    margin-right : 3px
  }

.eventmarketgroup >>>.alt-markets
.eventmarketgroup
  .event-market-header
    margin-top: 4px
    &.available-for-bb
      .icon-span
        float right
        .igt-icon
          position relative
          top -5px
    .market-name
      display flex
      background #fff
      border 1px solid #dcdfe9
      height: 40px
      padding 10px 15px
      margin: 0
      color #000
      cursor: default
      margin-bottom: -2px
      align-items center
      &:hover
        cursor: pointer
      &.expanded-market
        border-bottom-left-radius 0
        border-bottom-right-radius 0
      @media mobile-big-and-below
        margin-left: 4px
        margin-right: 4px
      .market-name-title
        font-size: 14px
        margin: 0px
        font-style: normal
        font-stretch: normal
        line-height: normal
      .icon-span
        text-align: right
        display: flex
        align-items: center
        justify-content: flex-end
      .available-for-bb
        display inline-block
        width 22px
        height 17px
        background url(icons-path'/'available-for-bb'.svg')
        // background: url("~@/s/svg/availible-for-bb.svg")
        background-repeat no-repeat
        margin-right 7px
        vertical-align middle
        background-size 100%
  .event-market-header.last
    margin-bottom: 4px

.eventmarketgroup * {
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: -moz-none;
    -o-user-select: none;
    user-select: none;
}

.stream-eventinfo-switcher
  padding 0 0 10px 0
  i
    color: #fff
    margin-top: 2px
    margin-right: 5px
  @media mobile-big-and-below
    display flex
    justify-content center
    margin-bottom 0px
    padding 10px 15px
  .tab
    background-color rgb(175, 1, 12)
    color #fff
    border-radius: 2px
    border none
    height 44px
    display inline-flex
    align-items center
    justify-content: center
    min-width 137px
    width auto
    margin 5px 0
    font-size 14px
    position relative
    z-index 2
    @media mobile-big-and-below
      width 100%
  .tab.disabled
    pointer-events: none !important
    opacity: 0.5
    cursor: not-allowed !important
    .icon
      color #fff
      font-size 15px
      border-radius 50%
      border 1px solid white
      margin-right 5px
    >>>.igt-icon > span
      margin-right 5px
  .tab.active
    // background-color #e4e8ee
    // color #1f375b
    display none


.video-streaming
  // padding-top 50px
  // padding-bottom: 10px
  // width 25vw
  margin auto
  min-height 239px
  padding-bottom: 13px
  text-align: center
  @media mobile-big-and-below
    padding: 0
    width: 100%
    min-height unset
    max-width 100%

  @media only screen and (min-width: 1024px) and (max-width: 1280px)
    padding-left 100px
    width 80%

.event_header
  background #0b4da1
  padding 10px
  // background: rgba(15,36,76,0.6)
  margin-bottom 10px

  .parent
    align-items center
    padding 0 25px
    @media mobile-big-and-below
      padding 0px
    .child-center
      text-align center
      margin-bottom 0 !important
      div
        padding 5px 0
      span
        display block
        font-size 18px
        @media mobile-big-and-below
          font-size 14px
      .time
        color #fedd00 !important
        font-family 'Open Sans Bold'
    .child-left
    .child-right
      margin-bottom 0 !important
      .team-title
        font-size 25px
        min-height 40px
        margin-bottom 0 !important
        @media mobile-big-and-below
          font-size 14px
        .pd-icon
          color #F2F700
          margin-left 5px
        @media mobile-big-and-below
          padding-left 0 !important
          line-height 15px
  .competition-live
    &.pre-match
    &.live-match
      margin 0px 0 14px 0 !important
      display flex
      align-items center
      justify-content center
.event-page
  .container.event
    >>>.popular_parlays_holder
      margin 5px 0 5px 0
  .eventmarketgroup.marketgroup
    display flex
    flex-direction column
  .toggle-container
    display flex
    justify-content flex-end
    align-items center
    padding-top 4px
    padding-right 5px
    font-size 15px
    height 40px
    background var(--coupon-bgr)
    color var(--coupon-text-color)
    font-family 'Roboto Condensed Bold'
    .order-toggle
      display flex
      align-items center
      border-radius 20px
      overflow hidden
      font-size 14px
      width 20%
      margin-left 5px
      border 1px solid var(--coupon-borders-color)
      text-align center
      position relative

      @media mobile-big-and-below
        width 40%

      &:before
        content ''
        position absolute
        top 3px
        bottom 3px
        left 4px
        width calc(50% - 4px)
        border-radius 20px
        background var(--more-tabs-btn-bgr)
        transform translateX(calc(var(--active-index, 0) * 100%))
        transition transform 0.25s ease

    .order-toggle__option
      padding 3px 6px
      margin 3px 4px
      cursor pointer
      user-select none
      width 50%
      border-radius 20px
      position relative
      z-index 1
      transition color 0.25s ease
    .order-toggle__option--active
      color var(--more-tabs-btn-color)
  .order-toggle-enabled
    padding-top 0 !important
.competition-name
  display flex
  align-items center
.fast_switch_holder
  height 45px
  padding 5px
  font-size 16px
  text-transform uppercase
  font-family 'Roboto Condensed Bold'
  background var(--event-header-competition-bgr)
  color var(--event-header-competition-color)
  display flex
  align-items center
.fast_swich_arrow_down
  display inline-flex
  margin-left 5px
  .v-icon
    color var(--event-header-competition-color)
    font-size 30px
.video-streaming-error-message
  height: 250px
  display: flex
  justify-content: center
  align-items: center
</style>



// WEBPACK FOOTER //
// src/components/sports/bettingoffer/event.vue